import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

interface PageMeta {
  title: string
  description: string
}

// The server renders the right <head> for the first load; this keeps it right
// for client-side navigations by asking the same resolver (Seo::PageMeta).
export function usePageMeta() {
  const { pathname } = useLocation()
  const first = useRef(true)

  useEffect(() => {
    if (first.current) {
      first.current = false
      return
    }

    let cancelled = false
    fetch(`/api/page_meta?path=${encodeURIComponent(pathname)}`, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? (response.json() as Promise<PageMeta>) : null))
      .then((meta) => {
        if (!meta || cancelled) return
        document.title = meta.title
        document.querySelector('meta[name="description"]')?.setAttribute('content', meta.description)
        document.querySelector('meta[property="og:title"]')?.setAttribute('content', meta.title)
        document.querySelector('meta[property="og:description"]')?.setAttribute('content', meta.description)
        document.querySelector('link[rel="canonical"]')?.setAttribute('href', window.location.origin + pathname)
      })
      .catch(() => {})

    return () => {
      cancelled = true
    }
  }, [pathname])
}
